import axios from 'axios'
const api = axios
const store = {
    actions: {
        getReporteTotalHours : async ({}, data) => {
            try{
                const response = await api.get('/report/totalhours/start/'+data.startDate+'/end/'+data.endDate)
                if(response.status === 200){
                    return response
                }
            }catch(error){
                return error.response;      
            }
        },
        getReporteTotalHoursByLumper : async ({}, data) => {
            try{
                const response = await api.get('/report/totalhours/lumper/start/'+data.startDate+'/end/'+data.endDate)
                if(response.status === 200){
                    return response
                }
            }catch(error){
                return error.response;      
            }
        }
    },
}
export default store